module.exports = "/assets/funding_postcode-46455bda7554054e23b300550d7d1a77.svg";